import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * "Uusittava" marker for a hotel card. The flag is the set's condition, separate from
 * where the set is (card.status), so it is shown next to the status chip, never instead
 * of it. Renders nothing when the card is not flagged.
 */
export default function NeedsReplacementChip({ card, t, size = 'small', sx }) {
  if (!card?.needs_replacement) return null;
  const chip = (
    <Chip
      size={size}
      icon={<WarningAmberIcon />}
      label={t('tire_hotel.needs_replacement')}
      color="warning"
      variant="outlined"
      data-testid="needs-replacement-chip"
      sx={{ fontSize: size === 'small' ? '11px' : undefined, ...sx }}
    />
  );
  if (!card.replacement_reason) return chip;
  return <Tooltip title={card.replacement_reason}>{chip}</Tooltip>;
}
